module.exports = __webpack_public_path__ + "static/media/3d-cube.df5a79b7.svg";